/* eslint-disable max-lines */
export const lorem =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";

export default {
  quickersim: "Quickersim",
  checkBestSolution: "Sprawdź, jakie rozwiązanie najbardziej Ci się opłaca.",
  stepper: {
    step1: "Profil poboru energii",
    step2: "OSD i taryfa dystrybucyjna",
    step3: "Sposób rozliczania za energię",
    step4: "Przyłącze i instalacja PV",
    step5: "Dane użytkownika",
    step6: "Wyniki",
  },
  stepTitles: {
    step1: "Profil poboru energii - dobowy",
    step2: "OSD i taryfa dystrybucyjna",
    step3: "Sposób rozliczania za energię",
    step4: "Przyłącze i instalacja PV",
    step5: "Dane użytkownika",
    step6: "Wyniki analizy",
  },
  clickHere: "Kliknij tutaj,",
  learnMore: "aby dowiedzieć się, w jaki sposób wykonujemy obliczenia.",
  back: "Wróć",
  next: "Dalej",
  wantFreeAnalysis: "Chcę otrzymać darmową analizę",
  step1: {
    q1: "W jaki sposób chcesz uzupełnić profil poboru energii?",
    q1_PREDEFINED_PROFILE: "Wybór predefiniowanego profilu",
    q1_TABLE_INPUT: "Uzupełnienie tabeli ze średnim zużyciem dobowym",
    q1_FILE_INPUT: "Wgranie pliku excel",
    profile_subForm: {
      q1: "Wybierz jeden z predefiniowanych profili",
      q1_ONE_SHIFT: "Praca jednozmianowa ze stałym poborem prądu",
      q1_TWO_SHIFTS: "Praca dwuzmianowa ze stałym poborem prądu",
      q1_THREE_SHIFTS: "Praca trzyzmianowa ze stałym poborem prądu",
      q2: "Wpisz zużycie miesięczne albo zużycie roczne",
      q2_MONTHLY: "Zużycie miesięczne",
      q2_YEARLY: "Zużycie roczne",
    },
    table_subform: {
      q1: "Uzupełnij tabelę średniego zużycia dobowego",
      hour: "Godzina",
      consumption: "Zużycie prądu",
    },
    file_subform: {
      q1: "Wgraj plik excel z profilem poboru prądu (wartości mocy podawaj w MW).",
    },
    validation: {
      predefinedProfile: "Wybierz predefiniowany profil",
      consumptionType: "Wybierz rodzaj zużycia",
      consumptionRequired: "Podaj wartość zużycia",
      tableNoData: "Uzupełnij tabelę zużycia",
      fileRequired: "Wgraj plik z profilem zużycia",
      tableValueRequired: "Podaj wartość zużycia",
      invalidExtension: "Nieprawidłowe rozszerzenie pliku. Dozwolone: {{ allowed }}.",
      fileTooLarge: "Plik jest zbyt duży. Maksymalny rozmiar to 10MB.",
      invalidType: "Nieprawidłowy typ pliku. Dozwolone: {{ allowed }}.",
      invalidColumnCount: "Plik musi zawierać dokładnie {{ required }} kolumny.",
      invalidRowCount:
        "Plik musi zawierać dokładnie {{ required }} wierszy (1 nagłówek + 24 wiersze danych).",
      invalidSecondColumnName: 'Nagłówek drugiej kolumny musi być "P_demand".',
      invalidDateFormat:
        "Nieprawidłowy format daty w kolumnie 1. Oczekiwany format: d.M.yyyy  HH:mm:ss (np. 1.10.2024  03:00:00).",
    },
  },
  step2: {
    q1: "Wybierz swojego Operatora Sieci Dystrybucyjnej",
    q2: "Wybierz swoją taryfę",
    q1_operator: "Operator",
    q2_tariff: "Taryfa",
    validation: {
      tariff: "Wybierz taryfę",
      operator: "Wybierz operatora",
    },
  },
  step3: {
    or: "albo",
    q1: "Jak rozliczasz się za energię?",
    q1_dynamic: "Stawka dynamiczna",
    q1_constant: "Stała cena",
    q1_tariff: "Taryfy głównych sprzedawców",
    q1_margin: "Marża",
    q1_fixedFee: "Opłata stała miesięczna",
    hintMarginAndFixedFee:
      "Opłata stała miesięczna jest dodawana do całego miesiąca i nie wpływa na marżę. Marża (zł/MWh) jest naliczana do każdej zakupionej jednostki energii.",
    q1_price: "Cena",
    q1_tariffLabel: "Taryfa",
    validation: {
      billingType: "Wybierz sposób rozliczania za energię",
      marginOrFixedFeeRequired: "Podaj marżę lub opłatę stałą miesięczną",
      fixedPriceRequired: "Podaj cenę",
      tariffRequired: "Wybierz taryfę",
    },
  },
  step4: {
    q1: "Jakie masz warunki przyłączeniowe? (opcjonalnie)",
    q2: "Czy jest możliwa sprzedaż energii do sieci?",
    q3: "Czy masz instalację PV?",
    importPower: "Import (opcjonalnie)",
    exportPower: "Export (opcjonalnie)",
    connectionPowerOverrideHintImportant: "Ważne:",
    connectionPowerOverrideHint:
      "Jeśli wpisana moc przyłączeniowa będzie niższa niż maksymalny pobór wynikający z Twoich danych profilowych, system automatycznie podniesie ją do najwyższej odnotowanej wartości poboru. Robimy to, aby zapewnić techniczną poprawność symulacji pracy magazynu energii.",
    exportPowerHint: "Jeśli możliwa jest sprzedaż energii do sieci, uzupełnij moc eksportową.",
    installationPower: "Moc instalacji po stronie DC (moc paneli) [MWp]",
    inverterPower: "Moc instalacji po stronie AC (moc falowników) [MW]",
    voivodeship: "Lokalizacja (województwo)",
    validation: {
      canSellEnergy: "Wybierz, czy jest możliwa sprzedaż energii do sieci",
      hasPvInstallation: "Wybierz, czy masz instalację PV",
      voivodeship: "Wybierz województwo",
      installationPowerRequired: "Podaj moc instalacji PV",
      exportPowerRecommended: "Podaj moc eksportową",
    },
  },
  step5: {
    q1: "Uzupełnij swoje dane",
    q1_companyName: "Nazwa Firmy",
    q1_email: "E-mail",
    q1_firstName: "Imię",
    q1_lastName: "Nazwisko",
    q1_phoneNumber: "Nr telefonu (opcjonalnie)",
    q2: "Zgody:",
    q2_selectAll: "Zaznacz wszystkie",
    q2_privacyPolicyRodo: "Zapoznałem/am się z Polityką prywatności i klauzulą informacyjną RODO",
    q2_dataAccuracyResponsibilityConsent:
      "Potwierdzam poprawność wprowadzonych danych. Przyjmuję do wiadomości, że kalkulator przetwarza dane w sposób automatyczny, a QuickerSim odpowiada wyłącznie za poprawność algorytmów obliczeniowych na bazie dostarczonych informacji.",
    q2_marketingEmailConsent:
      "Wyrażam zgodę na otrzymywanie informacji handlowych drogą elektroniczną na podany adres e-mail od {{companyName}}.",
    q2_marketingPhoneConsent:
      "Wyrażam zgodę na kontakt telefoniczny w celach marketingowych ze strony {{companyName}}.",
    q2_newsletterConsent: "Chcę otrzymywać newsletter od {{companyName}}.",
    q2_dataProcessingConsent:
      "Wyrażam zgodę na przetwarzanie moich danych w celu przygotowania i przedstawienia kalkulacji magazynu energii.",
    agreementNote: "* Zgoda obowiązkowa.",
    validation: {
      companyName: "Podaj nazwę firmy",
      firstName: "Podaj imię",
      lastName: "Podaj nazwisko",
      email: "Podaj poprawny adres e-mail",
      phoneNumber: "Podaj poprawny numer telefonu",
      privacyPolicyRodoRequired: "Wyrażenie zgody jest wymagane",
      dataAccuracyResponsibilityConsentRequired: "Wyrażenie zgody jest wymagane",
      dataProcessingConsentRequired: "Wyrażenie zgody jest wymagane",
      invalidEmail: "Podaj poprawny adres e-mail",
      invalidPhone: "Podaj poprawny numer telefonu",
    },
  },
  step6: {
    prepositions: {
      from_before_consonant: "z",
      from_before_vowel: "ze",
    },
    estimatedSavings: "Szacowana oszczędność z magazynu energii",
    calculationErrorMessage:
      "Nie udało się przeprowadzić obliczeń na podstawie podanych danych. Prosimy o ponowne wypełnienie formularza, upewnienie się, że wszystkie informacje są poprawne, i wysłanie go jeszcze raz.",
    bestSavings: "Największa oszczędność!",
    savingsDistribution: "Oszczędność na dystrybucji",
    feeSavings: "Oszczędność na opłacie mocowej",
    savingsPurchase: "Oszczędność na zakupie energii",
    savingsTotal: "Oszczędność sumaryczna",
    loadingHint:
      "Obliczenia mogą potrwać kilka minut. Możesz bezpiecznie zamknąć kartę – link do wyników otrzymasz e-mailem.",
    driverLabels: {
      optimal: "optymalnym sterowaniem QuickerSim",
      autoconsumption: "prostym sterowaniem maksymalizującym autokonsumpcję",
      autoconsumptionMinimizingPowerFee: "prostym sterowaniem minimalizującym opłatę mocową",
      autoconsumptionMaximizingAutoconsumption:
        "prostym sterowaniem maksymalizującym autokonsumpcję",
      fixed_hours: "prostym sterowaniem poprzez stały harmonogram",
    },
  },
  consumption: "Zużycie",
  powerConsumption: "Zużycie prądu",
  MWh: "MWh",
  MWhValue: "{{value}} MWh",
  MW: "MW",
  MWValue: "{{value}} MW",
  zl: "zł",
  zlValue: "{{value}} zł",
  hour: "Godzina",
  howDoWePerformCalculations: "W jaki sposób wykonujemy obliczenia?",
  iWantToReceiveFreeAnalysis: "Chcę otrzymać darmową analizę",
  refresh: "Odśwież",
  failedToLoadData: "Wystąpił błąd podczas ładowania danych.",
  noOptionsAvailable: "Brak dostępnych opcji.",
  yes: "Tak",
  no: "Nie",
  fullAnalysisCardTitle: "Chcesz się dowiedzieć jaki magazyn będzie dla Ciebie optymalny?",
  fullAnalysisCardSubtitle: "Zamów pełną analizę u naszego specjalisty.",
  orderFullAnalysisButton: "Zamów pełną analizę",
  resultsCard:
    "Wyniki analizy zostaną wyświetlone poniżej, może to zająć kilka minut. Link do wyników zostanie również przesłany na podany adres e-mail.",
  loading: "Wgrywanie...",
  fetchErrorMessage: "Wystąpił błąd podczas pobierania danych.\nSpróbuj odświeżyć.",
  summaryTitle:
    "Nasz specjalista wykona dla Ciebie szczegółową analizę, z której dowiesz się jaki magazyn będzie optymalny dla Twojego biznesu.",
  summarySubtitle: "Czego się dowiesz z analizy?",
  summaryPoints: {
    point1: "Ile możesz zaoszczędzić na rachunkach za energię dzięki magazynowi.",
    point2: "Czy inwestycja w magazyn opłaca się Twojej firmie.",
    point3: "Porównanie różnych strategii pracy magazynu.",
    point4: "Jaki magazyn jest idealny dla Twojej firmy.",
  },
  summary: {
    q1: "Sprawdź poprawność wprowadzonych wcześniej danych.",
    card1: "1. Twoje dane",
    card2: "2. Dane z formularza",
    card2Description:
      "Sprawdź poprawność wprowadzonych wcześniej danych. Edytuj klikając w ikonę ołówka.",
    card3: "3. Profil poboru z 1 roku",
    card3Description:
      "Wgraj plik excel z profilem poboru prądu z 1 roku - możesz go otrzymać od swojego Operatora Sieci Dystrybucyjnej.",
    card4: "4. Podsumowanie zamówienia",
    card4Description: "Podsumowanie",
    canSellEnergy: "Możliwość sprzedaży energii",
    pvInstallation: "Czy masz instalację PV",
    exportPower: "Export",
    importPower: "Import",
    installationPower: "Moc instalacji po stronie DC (moc paneli) [MWp]",
    inverterPower: "Moc instalacji po stronie AC (moc falowników) [MW]",
    billingMethod: "Sposób",
    price: "Cena",
    card4Info: "Wyniki zostaną przesłane na podany wyżej adres e-mail.",
    predefinedProfile: "Predefiniowany profil",
    excelFile: "Plik excel",
    table: "Tabela zużycia dobowego",
    monthlyConsumption: "Zużycie miesięczne",
    yearlyConsumption: "Zużycie roczne",
    consumptionType: "Rodzaj zużycia",
    file: {
      label:
        "Wgraj plik excel z profilem poboru prądu z 1 roku (wartości mocy podawaj w MW) - możesz go otrzymać od swojego Operatora Sieci Dystrybucyjnej.",
      exampleNote: "Pobierz i zobacz przykładowy plik",
      unitsHint: "Ważne: W pliku Excel wartości profilu mocy powinny być podane w MW.",
      exampleFileName: "przykład.xlsx",
      exampleDownloadToast: "Pobrano plik przykładowy.",
      validation: {
        required: "Wgraj plik Excel z profilem poboru prądu z 1 roku.",
        invalidExtension: "Nieprawidłowe rozszerzenie pliku. Dozwolone: {{ allowed }}.",
        fileTooLarge: "Plik jest zbyt duży. Maksymalny rozmiar to 10MB.",
        invalidType: "Nieprawidłowy typ pliku. Dozwolone: {{ allowed }}.",
        invalidColumnCount: "Plik musi zawierać dokładnie {{ required }} kolumny.",
        invalidSecondColumnName: 'Nagłówek drugiej kolumny musi być "P_demand".',
        invalidRowCount:
          "Plik musi zawierać dokładnie {{ required }} wierszy (1 nagłówek + 8760 wierszy danych godzinowych - 24 godziny dla 363 dni, 25 oraz 23 godziny dla dni ze zmianą czasu).",
      },
    },
  },
  payAndOrderFullAnalysis: "Zapłać i zamów analizę",
  price: "Cena",
  vat: "VAT 23%",
  totalPrice: "Łącznie",
  done: "Gotowe",
  mbOfMbMax: "{{mb}} MB z {{mb_max}} MB",
  powerDemand: "Maksymalny pobór mocy: {{value}} MW",
  dropOr: "Przeciągnij lub",
  selectFile: "wybierz plik.",
  cancel: "Anuluj",
  save: "Zapisz",
  selectingPredefinedProfile: "wybór predefiniowanego profilu",
  voivodeships: {
    LOWER_SILESIAN: "Dolnośląskie",
    KUYAVIAN_POMERANIAN: "Kujawsko-Pomorskie",
    LUBLIN: "Lubelskie",
    LUBUSZ: "Lubuskie",
    LODZ: "Łódzkie",
    LESSER_POLAND: "Małopolskie",
    MASOVIAN: "Mazowieckie",
    OPOLE: "Opolskie",
    SUBCARPATHIAN: "Podkarpackie",
    PODLASKIE: "Podlaskie",
    POMERANIAN: "Pomorskie",
    SILESIAN: "Śląskie",
    HOLY_CROSS: "Świętokrzyskie",
    WARMIAN_MASURIAN: "Warmińsko-Mazurskie",
    GREATER_POLAND: "Wielkopolskie",
    WEST_POMERANIAN: "Zachodniopomorskie",
  },
  formError: "Wystąpił błąd podczas wysyłania formularza. Spróbuj ponownie.",
  checkoutSessionError:
    "Nie udało się rozpocząć płatności. Spróbuj ponownie za chwilę. Jeśli problem będzie się powtarzał, skontaktuj się z nami.",
  checkoutAlreadyPaidError:
    "Ta kalkulacja została już opłacona. Sprawdź wyniki w wiadomości e-mail albo odśwież stronę, aby rozpocząć nowe obliczenia.",
  paymentSuccessTitle: "Płatność się powiodła!",
  thanksForUsingCalculator: "Dziękujemy za skorzystanie z kalkulatora!",
  paymentSuccessDescription:
    "Płatność się powiodła, zamówienie zostało przekazane do realizacji. Nasz specjalista wykona dla Ciebie szczegółową analizę, z której dowiesz się jaki magazyn będzie optymlny dla Twojego biznesu. Wyniki analizy prześlemy na podany w formularzu adres mail.",
  processingTimeInfo:
    "Realizacja zamówienia może zająć do kilku dni. W razie problemów bądź wątpliwości zapraszamy do kontaktu!",
  thanksForTrust: "Dziękujemy za zaufanie!",
  paymentFailureTitle: "Płatność się nie powiodła.",
  paymentFailureDescription:
    "Płatność się nie powiodła, zamówienie nie zostało opłacone. Aby zamówienie trafiło do realizacji spróbuj ponownie je opłacić.",
  retryPayment: "Spróbuj ponownie opłacić zamówienie",
  checkoutOpenedTitle: "Płatność została otwarta w nowej karcie",
  checkoutOpenedDescription:
    "Kontynuuj płatność w nowo otwartej karcie. Po zakończeniu zobaczysz tam potwierdzenie.",
  openPaymentAgain: "Otwórz płatność ponownie",
  contactInfo: "W razie wątpliwości zapraszamy do kontaktu!",
  fileDownloaded: "Pobrano plik.",
  errorDownloadingFile: "Wystąpił błąd podczas pobierania pliku. Spróbuj ponownie.",
  excelProfileUploadError: "Wystąpił błąd podczas wgrywania pliku Excel. Spróbuj ponownie.",
  howDoWePerformCalculationsDescription: `Aby wskazać najbardziej opłacalny magazyn energii dla Twojego domu lub firmy, kalkulator wykonuje serię inteligentnych obliczeń w oparciu o Twoje dane oraz realne warunki rynkowe:

#### 1. Analizujemy Twój profil zużycia energii
Pobieramy od Ciebie dane dotyczące:
- historycznego zużycia energii,
- operatora sieci (OSD),
- taryfy dystrybucyjnej,
- mocy przyłącza,
- instalacji PV.

Dodatkowo uwzględniamy ceny energii z ostatnich 12 miesięcy.
Jeśli podany profil zużycia obejmuje inny okres niż ostatni rok, dostosowujemy go tak, aby wiernie odzwierciedlał warunki z ostatnich 12 miesięcy.

#### 2. Odtwarzamy produkcję Twojej instalacji PV
Korzystamy z historycznych danych pogodowych, aby dokładnie odwzorować, ile energii mogła wygenerować Twoja instalacja w poszczególnych godzinach roku.

#### 3. Tworzymy zestaw możliwych magazynów energii
Na bazie Twojego profilu poboru i mocy przyłącza dobieramy listę pojemności i mocy magazynów, które mają sens w Twojej sytuacji.

#### 4. Symulujemy pracę każdego magazynu
Zaawansowany algorytm wyznacza najlepszy sposób ładowania i rozładowania magazynu. Uwzględniamy:
- zmienność cen energii,
- opłatę mocową i koszty dystrybucji,
- produkcję z PV,
- możliwość zarabiania na różnicy cen (arbitraż), jeśli przepisy na to pozwalają.

#### 5. Wybieramy rozwiązanie najbardziej opłacalne finansowo
Porównujemy oszczędności, jakie daje każdy magazyn, z jego szacowanym kosztem i wskazujemy ten, który wypada najlepiej.

*Uwaga: koszty magazynów opierają się na średnich cenach rynkowych – mogą różnić się od ofert konkretnych dostawców. Przed podjęciem decyzji inwestycyjnej warto to zweryfikować.*

**Podział odpowiedzialności:** Nasz kalkulator bazuje na zaawansowanych i zweryfikowanych algorytmach QuickerSim. Gwarantujemy poprawność matematyczną i logiczną symulacji dla wprowadzonych parametrów. Pamiętaj jednak, że wynik końcowy jest tak dobry, jak dane, które nam dostarczysz. Analiza ma charakter informacyjny i nie zastępuje oficjalnego projektu techniczno-ekonomicznego – nie ponosimy odpowiedzialności za decyzje inwestycyjne podjęte na jej podstawie.`,
};
